var map = {
	"./af.json": 2914,
	"./ar.json": 5310,
	"./be.json": 5144,
	"./bg.json": 4378,
	"./ca.json": 8109,
	"./cs.json": 3571,
	"./cz.json": 2728,
	"./da.json": 9914,
	"./de.json": 5894,
	"./dk.json": 896,
	"./ee.json": 9943,
	"./el.json": 4524,
	"./en.json": 4174,
	"./es.json": 6725,
	"./et.json": 6004,
	"./fi.json": 6808,
	"./fr.json": 4605,
	"./hi.json": 3134,
	"./hu.json": 6938,
	"./it.json": 3672,
	"./ja.json": 7980,
	"./ko.json": 9423,
	"./lt.json": 5449,
	"./lv.json": 1103,
	"./ms.json": 4525,
	"./no.json": 7086,
	"./pl.json": 1029,
	"./pt-BR.json": 6040,
	"./pt.json": 7741,
	"./ro.json": 2354,
	"./ru.json": 4600,
	"./sk.json": 347,
	"./sv.json": 8252,
	"./th.json": 9930,
	"./tr.json": 9755,
	"./uk.json": 2749,
	"./vi.json": 1496,
	"./zh-CN.json": 731,
	"./zh-TW.json": 1507
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3901;